import { Redirect, useLocalSearchParams } from 'expo-router';

export default function KursiPlayLegacyCourseManagementRedirect() {
  const { courseId } = useLocalSearchParams<{ courseId?: string | string[] }>();
  const canonicalId = Array.isArray(courseId) ? courseId[0] : courseId;
  return <Redirect href={canonicalId ? `/learn/creator/${encodeURIComponent(canonicalId)}` : '/learn/creator'} />;
}
